export default {
  DISPLAY: { path: '/projects/displays' },
  MATERIAL: { path: '/projects/materials' },
  PATROCINIO: { path: '/projects/sponsorships' },
  ADVERSIDADE: { path: '/projects/adversities' },
  PASTA: { path: '/projects/folders' },
  AMOSTRA: { path: '/projects/samples' },
  EVENTO: { path: '/projects/events' },
  REBATE: { path: '/projects/rebate' },
} as const;
